<template>
    <el-skeleton :rows="12" :loading="loading" animated>
        <template #default>

            <el-form ref="formRef" :disabled="saving" :rules="rules" :model="video" label-position="top">
                <el-form-item prop="title" label="Título do vídeo">
                    <el-input name="title" type="text" v-model="video.title" />
                </el-form-item>

                <el-form-item label="Adicione o vídeo">
                    <el-input v-model="file" type="file" ref="videoFile" name="video" @change="selectVideo" />
                </el-form-item>
                <video v-if="video.path" ref="prev" controls :style="{width: '100%'}">
                    <source :src="video.path">
                </video>

                <el-form-item label="Descrição" prop="description">
                    <el-input type="textarea" name="description" v-model="video.description" minlength="1" />
                </el-form-item>
        
                <el-button plain :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
                    Cadastrar
                </el-button>
            </el-form>

        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Video } from "@/services/types"
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus"
    import { nextTick, onBeforeMount, reactive, ref } from "vue"
    import { useStore } from "vuex"

    const store = useStore()
    const video = reactive<Video>({
        title: '',
        description: '',
        path: undefined,
        video: undefined
    })

    const rules = reactive<FormRules<Video>>({
        title: [{required: true, message: 'Insira o título do vídeo', min: 1}],
        description: [{required: true, message: 'Informe a descrição'}],
        video: [{required: true, message: 'adicione o vídeo'}]
    })

    const saving = ref<boolean>(false)
    const file = ref<string>()
    const videoFile = ref()
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)
    const prev = ref<HTMLVideoElement>()
   
    onBeforeMount(async () => {
        loading.value = false
    })


    const selectVideo = async () => {
        // verificar se e um video valido
        if (file.value && /\.(mp4|avi|webm)$/.test(file.value)) {
            console.log("Mudou o video 2")
            video.video = videoFile.value?.input.files[0]
            video.path = videoFile.value?.input.files[0] ? URL.createObjectURL(videoFile.value?.input.files[0]):undefined
            prev.value?.load()
        } else {
            ElMessage.error("Formato de ficheiro incorreto, escolha um vídeo com os formatos .mp4, .webm ou .avi")
            file.value = undefined
        }
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                if (!video.video) {
                    ElMessageBox.alert('Adicione o vídeo')
                    return
                }
                saving.value = true
                const data = new FormData()
                data.append('title', video.title)
                data.append('description', video.description)
                data.append('video', video.video)
                
                const res = await Api.post('admin/videos', video, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Video cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
